import { render, staticRenderFns } from "./pointOrder.vue?vue&type=template&id=0765fcc6&scoped=true&"
import script from "./pointOrder.vue?vue&type=script&lang=ts&"
export * from "./pointOrder.vue?vue&type=script&lang=ts&"
import style0 from "./pointOrder.vue?vue&type=style&index=0&id=0765fcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765fcc6",
  null
  
)

export default component.exports